import bd from "../icons/server-sharp.svg";
import fb from "../icons/logo-facebook-lead.svg";
import insta from "../icons/logo-instagram.svg";
import wats from "../icons/logo-whatsapp-lead.svg";
import tiktok from "../icons/logo-tiktok.svg";
import mundo from "../icons/earth.svg";
import diam from "../icons/diamond.svg";
import mano from "../icons/hand-right.svg";
import person from "../icons/person-lead.svg";
import imgOrigin from "../icons/image.svg";
import periodico from "../icons/newspaper-outline.svg";
import radio from "../icons/mic.svg";
import pesos from "../icons/logo-usd-lead.svg";
import revista from "../icons/library.svg";
import chats from "../icons/chatbubbles-outline.svg";
import trail from "../icons/trail-sign-outline.svg";
import call from "../icons/call-lead.svg";
import tv from "../icons/tv-outline.svg";
import receipt from "../icons/receipt-outline.svg";
import acess from "../icons/accessibility.svg";
import laptop from "../icons/laptop-outline.svg";
import help from "../icons/help.svg";
import google from "../icons/logo-google.svg";
import linkedin from "../icons/briefcase-sharp.svg";
import feliz from "../icons/emoji-feliz.png";
import serio from "../icons/emoji-serio.png";
import triste from "../icons/emoji-triste.png";
import congelado from "../icons/emoji-congelado.png";

export { feliz, serio, triste, congelado };

export function getOriginImage(origin) {
    switch (origin) {
        case 'Base_Datos':
        case 'Base Datos':
        case 'Base de Datos BBR':
            return bd;
        case 'Facebook':
        case 'Facebook_Desktop_Feed':
        case 'Facebook_Organic':
        case 'Facebook_Mobile_Feed':
        case 'Facebook_Instant_Articles':
        case 'Facebook Ads':
        case 'Facebook_Marketplace':
        case 'Facebook Forms':
            return fb;
        case 'Google':
        case 'Google Ads':
        case 'Google_Organic':
        case 'Google_ads':
            return google;
        case 'Instagram':
        case 'Instagram Ads':
        case 'Instagram_Explore':
        case 'Instagram_Feed':
            return insta;
        case 'Whatsapp':
        case 'WhatsApp':
        case 'Whatsapp Business':
        case 'whatsapp':
            return wats;
        case 'Tiktok':
        case 'TikTok':
        case 'tiktok':
            return tiktok;
        case 'Página web':
        case 'Pagina web':
        case 'Redes sociales':
        case 'Redes Sociales':
        case 'Web':
        case 'Sitio web Forms':
            return mundo;
        case 'LinkedIn':
        case 'Linkedin':
        case 'linkedin':
            return linkedin;
        case 'Broker':
        case 'Asesores Externos':
        case 'Broker o Asesor Externo':
            return diam;
        case 'Cambaceo':
            return mano;
        case 'Contacto Directo':
            return person;
        case 'Espectacular':
        case 'Espectacular South Hill (Carretera Celaya)':
        case 'Lonas':
            return imgOrigin;
        case 'Inmobiliaria Externa':
        case 'Señaletica':
        case 'Señalética':
            return trail;
        case 'Periodico':
        case 'Periódico':
            return periodico;
        case 'Radio':
            return radio;
        case 'Recompra':
            return pesos;
        case 'Revista':
            return revista;
        case 'Referidos':
        case 'RECOMENDACIï¿½N':
            return chats;
        case 'Telefono':
        case 'Teléfono':
            return call;
        case 'Televisión':
            return tv;
        case 'Volante':
            return receipt;
        case 'Inmuebles 24':
        case 'Lamudi':
        case 'Metros cúbicos':
        case 'Propiedades.com':
        case 'Segundamano':
        case 'Tu Hogar México':
        case 'Vivanuncios':
            return laptop;
        case 'Walk-in':
            return acess;
        default:
            return help;
    }
}

export function getOriginLabel(origin) {
    const labels = {
        'Base_Datos': 'Base de Datos',
        'Base Datos': 'Base de Datos',
        'Base de Datos BBR': 'Base de Datos',
        'Facebook_Desktop_Feed': 'Facebook Ads',
        'Facebook_Organic': 'Facebook',
        'Facebook_Mobile_Feed': 'Facebook',
        'Facebook_Instant_Articles': 'Facebook',
        'Facebook Ads': 'Facebook Ads',
        'Facebook_Marketplace': 'Facebook',
        'Facebook Forms': 'Facebook Forms',
        'Google_Organic': 'Google',
        'Google_ads': 'Google Ads',
        'Google Ads': 'Google Ads',
        'Instagram Ads': 'Instagram',
        'Instagram_Explore': 'Instagram',
        'Instagram_Feed': 'Instagram',
        'Página web': 'Página web',
        'Redes sociales': 'Redes sociales',
        'Redes Sociales': 'Redes sociales',
        'Sitio web Forms': 'Sitio web',
        'Pagina web': 'Página web',
        'LinkedIn': 'LinkedIn',
        'Linkedin': 'LinkedIn',
        'linkedin': 'LinkedIn',
        'Broker': 'Broker',
        'Asesores Externos': 'Broker',
        'Broker o Asesor Externo': 'Broker',
        'Espectacular South Hill (Carretera Celaya)': 'Espectacular',
        'Periodico': 'Periódico',
        'RECOMENDACIï¿½N': 'Referidos',
        'Señaletica': 'Señalética',
        'Telefono': 'Teléfono',
    };
    return labels[origin] || origin || '';
}

export function calculateDateDifference(reviewDate) {
    const currentDate = new Date();
    const lastContactDate = new Date(reviewDate);
    return Math.floor((currentDate - lastContactDate) / (1000 * 60 * 60 * 24));
}

export function getEmojiImage(differenceInDays, status) {
    if (status === 'Cierre') return feliz;
    if (differenceInDays <= 7)  return feliz;
    if (differenceInDays <= 13) return serio;
    if (differenceInDays <= 21) return triste;
    return congelado;
}

export function isDormido(differenceInDays, status) {
    return status !== 'Cierre' && differenceInDays > 90;
}

